import {
  TEST_CONNECTING,
  TEST_DATA,
} from 'store/types';

const INITIALSTATE = {
  timestamp: null,
  loading: null,
  data: [],
};

export default function (state = INITIALSTATE, action) {
  switch (action.type) {
    case TEST_CONNECTING:
      return {
        ...state,
        timestamp: new Date(),
        loading: true
      };
    case TEST_DATA:
      return {
        ...state,
        timestamp: new Date(),
        loading: false,
        ...action.payload
      };
    default:
      return state;
  }
}
